import axios from 'axios';
import store from '../index';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
const state = {
	items: [],
	item: {},
	index: '',
	sortBy: '',
	sortDesc: '',
};

const getters = {
	getItems: state => {
		return state.items;
	},
	getItem: state => {
		return state.item;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
};

const actions = {
	asyncFetchData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'coupon';

		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: context.rootGetters['coupon/getSortBy'],
						sortDesc: context.rootGetters['coupon/getSortDesc'],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				context.commit('setItems', res.data.data);
				return res.data.pagination;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	setUpdateStatusItem: async (context, payload) => {
		//console.log("parent",payload)
		//console.log(payload)
		let url = 'coupon/status';
		return await axios
			.patch(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: payload,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res);
				//context.commit('setCategories', res.data.data);
				return { data: res.data, level: payload.level };
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	deleteItem: async (context, settings) => {
		let url = `coupon/${settings._id}`;

		//console.log(context.rootGetters['categories/getSortBy'])
		return await axios
			.delete(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setCategories', res.data.data);
				return res.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err.response.status);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
				return { error: err.response.status };
				//throw Error(err.response.status);
			});
	},

	getDetail: async (context, payload) => {
		//console.log(payload)
		let url = `coupon/${payload._id}`;

		return await axios
			.get(
				`${context.rootGetters['settings/getUrl']}${url}`,

				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data?.data;
			})
			.catch(err => {
				console.log('errore', err);
			});
	},

	destroyData: context => {
		context.commit('setEmailtemplate', []);
		context.commit('setEmailtemplate', []);
		context.commit('setIndex', '');
	},
};

const mutations = {
	setItems: (state, value) => {
		state.items = value;
	},
	setItem: (state, value) => {
		state.item = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
